import { SetFormatBase } from "../../SetFormat";
import { CupModePoints } from "./CupModePoints";

export type CupModeFormatBase = SetFormatBase & {
  numTracks: number | undefined;
  playTillFinished: number | undefined;
  playTillLeft: number | undefined;
  points: CupModePoints;
  roundsPerTrack: number | undefined;
};

export type PlayTill = { type: "Left" | "Finished"; num: number };

export const getPlayTill = (format: CupModeFormatBase): PlayTill => {
  return !!format.playTillFinished
    ? { type: "Finished", num: format.playTillFinished }
    : { type: "Left", num: format.playTillLeft ?? 1 };
};

// If more finish than expected, limit to 1 to avoid removing score or drawing with finalist
export const getFcmWinnerPoints = (
  playTill: PlayTill,
  numRosters: number,
  numFinishedRosters: number
) => {
  if (playTill.type === "Finished") {
    return Math.max(playTill.num - numFinishedRosters, 1);
  }

  return Math.max(numRosters - playTill.num - numFinishedRosters, 1);
};

export const playTillReached = (
  playTill: PlayTill,
  numLeft: number,
  numFinished: number
) => {
  if (playTill.type === "Finished") {
    return numFinished >= playTill.num;
  }

  return numLeft <= playTill.num;
};
